import createIcon from '@/lib/create-icon'

const LanguageIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 16'>
    <path
      d='M9.71182 10.456L7.63364 8.448L7.65818 8.424C9.04473 6.91798 10.0804 5.13561 10.6936 3.2H13.0909V1.6H7.36364V0H5.72727V1.6H0V3.2H9.13909C8.59091 4.736 7.72364 6.2 6.54545 7.48C5.78455 6.656 5.15455 5.752 4.65545 4.8H3.01909C3.61636 6.104 4.43455 7.336 5.45727 8.448L1.29273 12.464L2.45455 13.6L6.54545 9.6L9.09 12.088L9.71182 10.456ZM14.3182 6.4H12.6818L9 16H10.6364L11.5527 13.6H15.4391L16.3636 16H18L14.3182 6.4ZM12.1745 12L13.5 8.536L14.8255 12H12.1745Z'
      fill='currentColor'
    />
  </svg>,
  'LanguageIcon'
)

export default LanguageIcon
